import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const RoleSelect = ({ title, defaultValue = null, handler, disabled }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("common.labels.role") : title;
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  const handleChange = (e) => {
    setSelectedRole(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getCategories = async () => {
    try {
      const accessLevel = parseInt(apiService.getAccessLevel());
      if (accessLevel === 100) return;
      const response = await apiService.get(`api/v1/roles`);
      const availableRoles = response.data
        .filter((el) => el.accessLevel < accessLevel)
        .map((el) => {
          return {
            value: el.id,
            label: el.name,
          };
        });

      setRoles(availableRoles);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedRole = roles.find((el) => el.value === defaultValue);
    if (selectedRole) setSelectedRole(selectedRole);
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    setNewValue();
    console.log(defaultValue);
  }, [defaultValue, roles]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          isDisabled={disabled}
          styles={customStyles}
          className="primary"
          name="roleSelect"
          onChange={handleChange}
          value={selectedRole}
          options={roles}
          noOptionsMessage={() => t("messages.noRolesAvailable")}
          placeholder={t("forms.placeholders.selectRole")}
        />
      </Form.Group>
    </>
  );
};

export default RoleSelect;
